module.exports = __webpack_public_path__ + "mobile_phone.e8b610f4ff9674bde04d24e4effeba6f.svg";